<template>
  <el-dialog
    :visible.sync="visible"
    width="500px"
    placement="center"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    :show-close="false"
    @close="close"
    class="AuthenticationDialog"
  >
    <template slot="title">
      <div class="title">身份验证</div>
      <i class="el-icon-close" style="cursor: pointer" @click="close"></i>
    </template>
    <div class="info">
      <el-form
        ref="form"
        :data="formData"
        :colon="false"
        label-position="left"
        label-width="80px"
        class="Authentication"
        :requiredMark="false"
        :hide-required-asterisk="true"
      >
        <div class="text-info" v-if="type == 'phone'">
         <i class="iconfont icon-Vector"></i> 为了你的账号安全，请先通过绑定手机号码验证身份
        </div>
        <div class="text-info" v-if="type == 'email'">
         <i class="iconfont icon-Vector"></i> 为了你的账号安全，请先通过绑定邮箱验证身份
        </div>
        <div class="cellPhone" v-if="type == 'phone'">
          已绑定手机
          <span class="phone">{{ info.telCode }} {{ info.mobile }}</span>
        </div>
        <div class="cellPhone" v-if="type == 'email'">
          已绑定邮箱 <span class="phone">{{ info.userEmail }}</span>
        </div>
        <el-form-item label-width="0" prop="validateCode">
          <el-input
            placeholder="请输入验证码"
            style="margin-right: 10px"
            maxlength="6"
            :style="timeout.status == 2 ? 'width: 67%' : 'width: 74%'"
            v-model.trim="formData.validateCode"
          ></el-input>
          <el-button
            style="width: 102px"
            type="primary"
            v-if="timeout.status == 1"
            @click="requestAuthCode"
            >获取验证码</el-button
          >
          <el-button
            style="
              width: 132px;
              background: #cfd5df;
              border: none;
              color: #ffffff;
            "
            v-else-if="timeout.status == 2"
            :disabled="true"
            >{{ timeout.time || 0 }}秒后可重新获取</el-button
          >
          <el-button
            type="primary"
            style="width: 102px"
            v-else
            @click="requestAuthCode"
            >重新获取</el-button
          >
        </el-form-item>
        <el-form-item class="btn">
          <el-button
            :loading="loading"
            :disabled="formData.validateCode.length < 6"
            type="primary"
            @click="onSubmit('form')"
            >下一步</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import {
  getAccountMobileCode,
  getAccountValidateSecurity,
  getAccountEmailCode,
} from "@/utils/api/account";
export default {
  props: {
    visible: Boolean,
    info: Object,
    type: String, // phone  手机   email 邮箱
    typeCode: Number, //1：解绑手机/邮箱 2：更换手机/邮箱-新手机号/新邮箱发送验证码 3:绑定手机 4:更换手机/邮箱-已绑定手机号/邮箱发送验证码 5:已绑定手机号/邮箱安全校验 6:重置密码-已绑定手机号/邮箱发送验证码,示例值(4)
    isPassword: Boolean, //否是修改密码的身份验证
  },
  data() {
    return {
      loading: false,

      formData: {
        validateCode: "", // 短信验证码
      },
      form: null,
      timeout: {
        time: 60,
        status: 1, // 1: 未发送 2: 倒计时 3: 发送超时
        main: null,
      },
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.formData.validateCode = "";
        this.loading = false;
        clearInterval(this.timeout.main);
        this.timeout.main = null;
        this.timeout.time = 60;
        this.timeout.status = 1;
      }
    },
  },
  methods: {
    async validateAndRequestCode(requestFn, successCallback) {
      try {
        const { rspResult, data } = await requestFn({
          type: this.typeCode,
        });
        if (rspResult.bizCode === 200) {
          this.timeout.status = 2;
          this.timeout.time = data.second;
          this.timeout.main = setInterval(() => {
            this.timeout.time--;
            if (this.timeout.time <= 0) {
              this.timeout.status = 3;
              this.timeout.time = 60;
              clearInterval(this.timeout.main);
              this.timeout.main = null;
            }
          }, 1000);
        }
      } catch (error) {
        console.error("❌ ~ requestAuthCode ~ error:", error);
      }
    },

    // 点击获取验证码
    async requestAuthCode() {
      if (this.type === "phone") {
        await this.validateAndRequestCode(getAccountMobileCode);
      } else if (this.type === "email") {
        await this.validateAndRequestCode(getAccountEmailCode);
      }
    },
    // 弹框关闭
    close() {
      this.$refs.form.resetFields();
      this.$emit("close");
    },
    onSubmit(formName) {
      console.log(this.$refs[formName]);

      if (this.timeout.status === 1) {
        return this.$message.warning("请获取验证码");
      }
      this.loading = true;
      getAccountValidateSecurity(
        {
          validateCode: this.formData.validateCode,
          type: this.typeCode,
        },
        {
          source: this.type == "phone" ? 1 : 2,
        }
      ).then((res) => {
        const bizCode = res.rspResult.bizCode;
        const codeArr = [401, 403, 404, 1302];
        if (bizCode === 200) {
          this.loading = false;
          this.$refs.form.resetFields();
          this.$emit("submit", this.type, this.isPassword);
        }  else {
          this.loading = false;
        }
        console.log(res);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.AuthenticationDialog .el-dialog {
  padding: 32px;
  border-radius: 8px;
  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    padding: 0;
  }
  .el-dialog__body {
    padding: 8px 0 0;
  }
}

.Authentication {
  .el-form__label {
    color: rgb(79, 93, 120);
    height: 32px;
    line-height: 32px;
  }
  .text-info {
    //background-color: #f5f7fa;
    color: #4f5d78;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    padding: 16px 0px;
    margin-bottom: 24px;
    .icon-Vector{
      color: #FF9A3E;
      margin-right: 2px;
    }
  }
  .cellPhone {
    color: #16181a;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    margin-bottom: 16px;
    .phone {
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .btn {
    text-align: right;
    margin-top: 24px !important;
    .el-form__controls .el-form__controls-content {
      justify-content: flex-end;
    }
  }
}

.title {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}
</style>
